export enum ItemStatusEnum {
  Sellable = '0',
  ToBeDiscontinued = '8',
  Discontinued = '9',
}

export type ItemStatus =
  | ItemStatusEnum.Sellable
  | ItemStatusEnum.ToBeDiscontinued
  | ItemStatusEnum.Discontinued;
